// removed by extract-text-webpack-plugin
module.exports = {"Sorting":"KsZKtA0Iyg_YtgwvvKNjy","Item":"hvkXfG_QNVZeLn-VBVw50","Number":"_3usg7zdSM1gSTynlpHhySn","Name":"_3ggBuixFYRGBkOZ4fPLju_","Date":"_3TbNBrDCHUBbk5GUAZtu0o","Ellipsis":"_3Y-OTIcfnDG6Zxuqe4Eu2k"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/History/style.css
// module id = 855
// module chunks = 0